import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "el_pop_data_group"
};
var _hoisted_2 = {
  "class": "el_pop_data_headings"
};
var _hoisted_3 = ["data-item_index", "onClick"];
var _hoisted_4 = {
  "class": "el_pop_data_body"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  key: 0,
  "class": "input-textarea-value"
};
var _hoisted_7 = {
  "class": "dashicons fc_clickable dashicons-database"
};
var _hoisted_8 = {
  "class": "dashicons dashicons-database"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_popover = _resolveComponent("el-popover");
  var _component_el_input = _resolveComponent("el-input");
  var _directive_popover = _resolveDirective("popover");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_popover, {
    ref: "inputpopoverref",
    placement: "right-end",
    "virtual-triggering": "",
    persistent: "",
    "popper-class": 'fcrm-smartcodes-popover el-dropdown-list-wrapper ' + $props.popper_extra,
    modelValue: $data.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.visible = $event;
    }),
    trigger: "click"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, function (item, item_index) {
        return _openBlock(), _createElementBlock("li", {
          "data-item_index": item_index,
          key: item_index,
          "class": _normalizeClass($data.activeIndex == item_index ? 'active_item_selected' : ''),
          onClick: function onClick($event) {
            return $data.activeIndex = item_index;
          }
        }, _toDisplayString(item.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_3);
      }), 128 /* KEYED_FRAGMENT */))])]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, function (item, current_index) {
        return _openBlock(), _createElementBlock("div", {
          key: current_index
        }, [_withDirectives(_createElementVNode("ul", {
          "class": _normalizeClass('el_pop_body_item_' + current_index)
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.shortcodes, function (label, code) {
          return _openBlock(), _createElementBlock("li", {
            onClick: function onClick($event) {
              return $options.insertShortcode(code);
            },
            key: code
          }, [_createTextVNode(_toDisplayString(label), 1 /* TEXT */), _createElementVNode("span", null, _toDisplayString(code), 1 /* TEXT */)], 8 /* PROPS */, _hoisted_5);
        }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */), [[_vShow, $data.activeIndex == current_index]])]);
      }), 128 /* KEYED_FRAGMENT */))])])];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["popper-class", "modelValue"]), $props.fieldType == 'textarea' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_withDirectives(_createElementVNode("span", _hoisted_7, null, 512 /* NEED_PATCH */), [[_directive_popover, void 0, "input-popover"]]), _createVNode(_component_el_input, {
    placeholder: $props.placeholder,
    rows: 4,
    type: "textarea",
    modelValue: $data.model,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.model = $event;
    })
  }, null, 8 /* PROPS */, ["placeholder", "modelValue"])])) : (_openBlock(), _createBlock(_component_el_input, {
    key: 1,
    "class": "fc_pop_append",
    placeholder: $props.placeholder,
    modelValue: $data.model,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.model = $event;
    }),
    type: $props.fieldType
  }, {
    append: _withCtx(function () {
      return [_withDirectives(_createElementVNode("span", _hoisted_8, null, 512 /* NEED_PATCH */), [[_directive_popover, void 0, "inputpopoverref"]])];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["placeholder", "modelValue", "type"]))]);
}